export enum NavigationIcon  {
  REPORTS = "reports",
  SETTINGS = "settings",
  HELP = "help",
  LOGOUT = "logout"
}

export enum NavigationId {
  REPORTS = "reports",
  SETTINGS = "settings",
  HELP = "help",
  LOGOUT = "logout"
}

export enum NavigationType {
  LINK_INTERNAL = "link-internal",
  LINK_EXTERNAL = "link-external",
  BUTTON = "button"
}